import { Image, ImageDetail, LanguageEnum, MetaFields, MetaFieldsItem } from "types/api/commons";

export type RugianoProjectBody = {
    type: RugianoProjectTypeEnum;
    slug: string;
    name: string;
    year: number | null;
    location: string | null;
    designer: string | null;
    graphical_order: number | null;
    enabled: boolean;
    thumb: Image;
    text: MetaFields;
};

export type RugianoProjectListItem = {
    id: string;
    type: RugianoProjectTypeEnum;
    slug: string;
    name: string;
    thumb_id: string;
    year: number | null;
    location: string | null;
    designer: string | null;
    graphical_order: number | null;
    block_group_id: string | null;
    enabled: boolean;
    mobile_id: string;
    mobile_filename: string;
    desktop_id: string;
    desktop_filename: string;
};

export type RugianoProjectDetails = {
    id: string;
    type: RugianoProjectTypeEnum;
    slug: string;
    name: string;
    thumb_id: string;
    year: number | null;
    location: string | null;
    designer: string | null;
    graphical_order: number | null;
    block_group_id: string | null;
    enabled: boolean;
    thumb: ImageDetail;
    // backend only returns entries for languages that already have a bo_rugiano_projects_languages row
    text: Partial<Record<LanguageEnum, MetaFieldsItem>>;
};

export enum RugianoProjectTypeEnum {
    CONTRACT = "contract",
    PRIVATE = "private",
}
